import * as R from 'remeda';

export type Field<T> = { value: T; touched: boolean; dirty: boolean };

export function initialField<T>(value: T): Field<T> {
  return { value: value, touched: false, dirty: false };
}

export function updateValue<T>(field: Field<T>, value: T): Field<T> {
  return R.pipe(field, R.set('value', value), R.set('dirty', true));
}

export function touchField<T>(field: Field<T>): Field<T> {
  return R.pipe(field, R.set('touched', true));
}
